import { render } from "./SymptomReportFollowupView.vue?vue&type=template&id=0d6070a8&scoped=true"
import script from "./SymptomReportFollowupView.vue?vue&type=script&lang=js"
export * from "./SymptomReportFollowupView.vue?vue&type=script&lang=js"

import "./SymptomReportFollowupView.vue?vue&type=style&index=0&id=0d6070a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6070a8"]])

export default __exports__